/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select, Input } from 'antd';

const MergeColumnsForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={config} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item
            label="Columns to Merge (select multiple)"
            name="columns"
            rules={[{ required: true, type: 'array', min: 2, message: 'Select at least two columns' }]}
            help="Hold Ctrl/Cmd to select multiple"
        >
            <Select
                mode="multiple"
                placeholder="Select columns to merge"
                options={columns.map(c => ({ label: c, value: c }))}
            />
        </Form.Item>
        <Form.Item label="New Column Name" name="newColumnName" rules={[{ required: true }]}>
            <Input placeholder="e.g., full_address" />
        </Form.Item>
        <Form.Item label="Separator" name="separator" rules={[{ required: true }]}>
            <Input placeholder="e.g., space or comma" />
        </Form.Item>
    </Form>
);

export default MergeColumnsForm;
